import { superGrids, SuperGridType } from '@/superGrids.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { useEffect } from 'react';
import { useForm } from '@/form/useForm.ts';

export const useSkipOnSupergrid = (superGridKeys: SuperGridType[]) => {
  const { skipToNext } = useNavigation();

  const { getFieldValue } = useForm();
  useEffect(() => {
    const donorId = getFieldValue('donorId') as string;

    const skipgrids = superGridKeys.map((key) => superGrids[key].grid.toUpperCase());
    if (skipgrids.includes(donorId!.toUpperCase())) {
      skipToNext();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
